import AgTechGrid from '@agtech/web/components/Grids/AgTechGrid';
import AgTechGridLink from '@agtech/web/components/Grids/Controls/AgTechGridLink';
import { AgTechGridProps } from '@agtech/web/components/Grids/Data/AgTechGridProps';
import dayjs from 'dayjs';
import React from 'react'
import { ContactNoteActionButton } from '../../components/buttons/ContactNoteButtons';
import ContactNoteDialog from '../../dialogs/notes/ContactNoteDialog';
import { useAgTechOptionalQuery } from '@agtech/core/data/queries/AgTechDataQueries';
import { ContactNote } from '@agtech/data/contacts/notes/ContactNoteData';
import { ContactDataGetContactNotesQuery } from '@agtech/data/contacts/notes/ContactNoteDataQueries';

export type ContactNotesGridProps = {
    contactId: number,
    notes?: ContactNote[],
    gridProps?: (props: AgTechGridProps<ContactNote>) => AgTechGridProps<ContactNote>
}

const ContactNotesGrid = (props: ContactNotesGridProps) => {
    const getNotesQuery = useAgTechOptionalQuery({
        query: ContactDataGetContactNotesQuery,
        queryContext: {
            contactId: props.contactId
        },
        data: props.notes ? { notes: props.notes } : undefined,
        projection: (data) => ({
            items: data.notes
        })
    });

    return (
        <AgTechGrid
            header={{
                title: 'Notes',
            }}
            data={{
                itemQuery: getNotesQuery
            }}
            columns={[
                {
                    header: 'Date',
                    value: note => dayjs(note.date).format('MM/DD/YYYY'),
                    width: '100px'
                },
                {
                    header: "Note",
                    value: note =>
                        <AgTechGridLink content={note.note}
                            onClick={(e => e.dialogs.openDialog({
                                dialog: () => (
                                    <ContactNoteDialog
                                        contactId={props.contactId}
                                        note={note}
                                    />
                                )
                            }))}
                        />,
                    size: 2
                }
            ]}
            isRowEntityTheSame={(prev, curr) => {
                return prev.date === curr.date &&
                    prev.note === curr.note;
            }}
            noRecordsConfig={{
                message: 'No notes were found for this contact',
                action: {
                    prompt: 'To create one, click the button below',
                    button: () => (
                        <ContactNoteDialog.Button
                            contactId={props.contactId}
                            classes='button-highlight'
                        />
                    )
                }
            }}
            actions={{
                width: '36px',
                rendering: note => (
                    <ContactNoteActionButton
                        contactId={props.contactId}
                        note={note}
                    />
                )
            }}
            propModifier={props.gridProps}
        />
    )
}

export default ContactNotesGrid;